import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import ROUTES from '../routes';
import api from './../config/axiosInstance';
import { handleErrors } from '../utils/common';
import { fetchAndSetUserProfile } from '../config/authActions';
import { useDispatch } from 'react-redux';

const EmailVerify = () => {
    const dispatch = useDispatch();
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const res = await api.get(`/auth/verify-email/${token}`);
    
                if (res.status === 200) {
                    dispatch(fetchAndSetUserProfile());
    
                    setTimeout(() => {
                        navigate(ROUTES.PROFILE);
                    }, 1000);
                }
            } catch (err) {
                handleErrors(err);
            }
        };
    
        if (token) verifyEmail();
    }, [token, navigate, dispatch]);
    

    return <></>;
};

export default EmailVerify;
